module.exports = "/_next/static/files/622896682569e635fe7e974749594715.svg";